var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOilChangeCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.55 448.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #f26725;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 8.14px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.15,136.9c-33.08-33.46-65.92-53.59-67.3-54.43-.96-.58-2.05-.89-3.17-.89-1.52,0-3,.56-4.16,1.56-2.03,1.76-2.71,4.75-1.62,7.28.16.4,4.03,10.01,1.98,26.49-1.9,15.32-9.43,40.13-34.44,71.3l-.22.24c-10.34,10.3-39.87,48.23-39.87,86.17,0,50.91,48.49,92.33,108.09,92.33s107.75-41.4,108.09-92.29c.3-45.23-23-92.88-67.37-137.78ZM148,189.65,139.24,267.41c0-3.41,2.76-6.17,6.17-6.17s6.17,2.76,6.17,6.17c0,0-1.43,29.1,25.39,47.83,22.28,15.86,44.09,18.05,44.09,18.05-44.69,7.16-81.82-20.79-81.82-65.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilChangeCredit);
export default __webpack_public_path__ + "static/media/Oil Change Credit.7e31617f73fb9860c4e619ff1be78f20.svg";
export { ForwardRef as ReactComponent };